import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Loading } from './helpers/Star'
import { twitterverse } from './helpers/links'

// custom hook to get the current pathname in React

const ConnectEmail = () => {
  const [renderEmail, setRenderEmail] = useState(false)
  const [renderThankYou, setRenderThankYou] = useState(false)
  const [loading, setLoading] = useState(false)
  const textInput = React.createRef()

  const baseUrl = `https://twitterverse-px.vercel.app/email`
  // const baseUrl = `http://localhost:3001/email`

  const getUser = async () => {
    const wait = 20
    const waitMs = wait * 1000

    function waiting() {
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
        setRenderEmail(true)
      }, waitMs)
    }
    waiting()
  }

  const getEmail = async () => {
    // fetch
    setLoading(true)

    let result
    const emailBody = textInput.current.value

    const req = {
      email: emailBody,
    }

    await fetch(baseUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data)
        result = data
      })
      .catch((error) => {
        console.log(error)
      })

    if (result) {
      setLoading(false)
      setRenderThankYou(true)
    }
  }

  if (loading === true) {
    return (
      <div>
        <div className="main loading_main">
          <h2 className="loading_title">This might take a minute...</h2>
          <div className="loading_star--container">
            <Loading />
          </div>
        </div>
      </div>
    )
  }

  if (renderEmail === false && renderThankYou === false) {
    return (
      <div>
        <div className="main loading_main">
          <h4 className="loading_header">Celebrate Twitter’s 15th Anniversary</h4>
          <h2 className="loading_title">see + share your top tweets of all time</h2>
          <div className="loadingInput">
            <form action="">
              <input ref={textInput} type="type" placeholder="@username" />
              <button onClick={getUser}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    )
  }
  if (renderEmail === true && renderThankYou === false) {
    return (
      <div>
        <div className="main loading_main">
          <h4 className="loading_header loading_header-sorry">Sorry for the wait. Enter your email and we{`'`}ll send you the results ASAP.</h4>
          <div className="loadingInput">
            <form action="">
              <input ref={textInput} type="type" placeholder="Email" />
              <button onClick={getEmail}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    )
  }
  // else
  return (
    <div>
      <div className="main loading_main">
        <h4 className="loading_header" style={{ width: '40vw', lineHeight: '1em' }}>
          Thanks!
        </h4>
        <div className="loadingInput">
          <NavLink to={twitterverse} className="button twitterverse_make-your-own">
            Back to The Twitterverse
          </NavLink>
        </div>
      </div>
    </div>
  )
}

export default ConnectEmail
